import { HoverTooltip } from '@/core/HoverTooltip.atom';
import _ from 'lodash';
import { sqItemsApi } from '@/sdk/api/ItemsApi';
import clsx from 'clsx';
import { addTrendItem } from '@/trendData/trend.actions';
import type { TooltipPosition } from '@seeqdev/qomponents';
import { useAllTrendStoreItems } from '@/core/hooks/useAllTrendStoreItems.hook';

interface AddToDisplayPaneIF {
  itemId: string;
  tooltip?: string;
  extraClassNames?: string;
  tooltipPlacement?: TooltipPosition;
  afterAdd?: (itemId: string) => Promise<void> | void;
  outputItemId?: string;
}

export const AddToDisplayPane: React.FunctionComponent<AddToDisplayPaneIF> = (props) => {
  const { itemId, tooltip, extraClassNames, tooltipPlacement, afterAdd, outputItemId } = props;

  const trendItems = useAllTrendStoreItems();

  if (_.some(trendItems, { id: itemId })) {
    return null;
  }

  const addToDisplay = () => {
    let scalingItemProps: Record<string, unknown> | undefined;
    if (outputItemId) {
      const outputItem = _.find(trendItems, { id: outputItemId });
      scalingItemProps = {
        tableId: _.get(outputItem, 'tableId'),
        rowId: _.get(outputItem, 'rowId'),
        columnId: _.get(outputItem, 'columnId'),
      };
    }
    sqItemsApi
      .getItemAndAllProperties({ id: itemId })
      .then(({ data: item }) => addTrendItem(item, scalingItemProps))
      .then(() => (afterAdd ? afterAdd(itemId) : undefined));
  };

  return (
    <HoverTooltip placement={tooltipPlacement || 'right'} text={tooltip || 'ADD_TO_DISPLAY'}>
      <a
        data-testid="addToDisplay"
        className={clsx(
          'displayIcon a fa-sharp fa-regular fa-chart-area link-no-underline animated animate-if-opacity pt2 pl5' +
            ' force-link-color',
          extraClassNames,
        )}
        onClick={addToDisplay}
      />
    </HoverTooltip>
  );
};
